<template>
  <el-footer class="admin-footer">
    <div class="footer-container">
      <div class="footer-item">
        <a href="mailto:sales@audiotestkitchen.com">
          <span>Sales</span>
        </a>
      </div>
      <div class="footer-item">
        <span @click="$router.push('/client/guide')">Support</span>
      </div>
      <div class="footer-item">
        <span @click="$router.push('/privacy')">Privacy</span>
      </div>
      <div class="footer-item">
        <span @click="$router.push('/terms')">Terms of Use</span>
      </div>
      <div class="footer-item">
        <a href="https://www.audiotestkitchen.com/blog" target="_blank">
          <span>Audio Test Kitchen Blog</span>
        </a>
      </div>
      <div class="footer-item">
        <span>©{{ currentYear }} Audio Test Kitchen. All Rights Reserved</span>
      </div>
    </div>
  </el-footer>
</template>
<script>
export default {
  name: 'ClientFooter',
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>
<style scoped>
.admin-footer {
  height: auto;
  padding: 22px 0;
}
</style>
